import type { FaireProductEntity } from "../../entity_types/product";

export const p_4xbq9tzhj2: FaireProductEntity = {
  token: "p_4xbq9tzhj2",
  type: "product",
  name: "Travel Large Capacity Canvas Duffle Tote Bag",
  brandToken: "b_4hfzm6sugt",
  brandName: "GirlyPirateCo",
  imageUrl:
    "https://cdn.faire.com/fastly/a48e333c29d67e52f98437b8b3ae3d2a67d39280e219fa06380611f180e64387.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/197ddf5702905e494316ac650d56150cc21a73eb381e03b01dd752baa6a420dd.jpeg",
    "https://cdn.faire.com/fastly/b3cb94c48ae63e7f1d070db7d737da39700207f656d1832001cae3a774c72309.jpeg",
    "https://cdn.faire.com/fastly/111123111ade7f0460cd5c2bdf298988a7e617ddd02be80394b19e5861cf7f1c.jpeg",
    "https://cdn.faire.com/fastly/6eb550310f4fde2eb68d6bb2ef3a8cab7283e2d61b69234c528729fc26f7dc59.png",
    "https://cdn.faire.com/fastly/4e54e334b81c02c50680d52ce8714280b8ce760de983a315cae7a213c2ecb299.png",
    "https://cdn.faire.com/fastly/2e3b022cd0b931123c03cbe6e6213fa259daa2e67532547d1409483558b552d0.jpeg",
    "https://cdn.faire.com/fastly/62610d3ed7a6d30eed5e8c66a288c9866d63b7d1d15d271e4b5eb3cee7b062b1.jpeg",
  ],
  priceDollars: 34.64,
  description:
    "This large-capacity travel duffel bag is designed for weekend getaways, business trips, and everyday travel needs. Made from durable canvas with reinforced stitching, it features multiple compartments to keep your belongings organized, including a spacious main compartment for clothes, shoes, and accessories. The adjustable and removable shoulder strap offers comfortable carrying options, while the sturdy handles ensure easy grab-and-go convenience. Suitable for men and women, this versatile tote doubles as an overnight bag, gym bag, or carry-on luggage. Stylish yet practical, it’s the perfect companion for your next adventure.",
  tags: [],
  msrpDollars: 69.28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:33.636Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
